module.exports = __webpack_public_path__ + "static/merch2-33e1a4e22e7a49664160e0b8c878d418.png";